import { toNumber } from 'lodash';

export const setAnimateProgress = ($: JQueryStatic) => {
	const PROGRESS_OVERLAY_CLASS = 'b-progress-overlay';
	const PROGRESS_BODY_OVERFLOW_CLASS = 'b-progress-body_overflow';
	const ieDetector = (userAgent: string): number | boolean => {
		let ieVersion: number | null = null;

		const regExp: { [key: number]: RegExp } = {
			9: /Trident\/5/i,
			10: /Trident\/6/i,
			11: /Trident\/7/i,
		};

		for (const key in regExp) {
			if (regExp.hasOwnProperty(key)) {
				if (regExp[key].test(userAgent)) {
					ieVersion = toNumber(key);
				}
			}
		}

		return ieVersion || false;
	};

	const isIe = ieDetector(window.navigator.userAgent);
	const getTemplate = (label: string) => '<div class="b-progress-wrapper"><div class="b-progress-label">' + label + '</div><div class="b-progress"><div class="b-progress-indeterminate"><div class="b-progress-ie"></div></div></div></div>';
	let animateProgressCounter = 0;

	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore  next-line
	$.animateProgress = (params: { container: string | JQuery<any>; isFixed?: boolean; label?: string }) => {
		const container = typeof params.container === 'string' ? $(params.container) : params.container;
		const body = $('body');
		let progressEl: JQuery<HTMLElement>;
		let progressElWidth: number;

		params.isFixed = params.isFixed !== false;

		function animate () {
			progressEl
				.css('left', -progressElWidth)
				.animate({ left: '100%' }, 2000, 'easeInOutCirc', animate);
		}

		function enable () {
			const hasBodyOverflowClass = body.hasClass(PROGRESS_BODY_OVERFLOW_CLASS);

			container
				.addClass(PROGRESS_OVERLAY_CLASS + (params.isFixed ? '' : ' is-absolute'))
				.html(getTemplate(params.label as string));

			if (isIe && isIe < 11) {
				progressEl = container.find('.b-progress-ie');
				progressElWidth = progressEl.width()!;

				animate();
			}

			if (params.isFixed) {
				animateProgressCounter++;
			}

			if (!hasBodyOverflowClass && params.isFixed) {
				body.addClass(PROGRESS_BODY_OVERFLOW_CLASS);
			}
		}

		function disable () {
			container.removeClass(PROGRESS_OVERLAY_CLASS + (params.isFixed ? '' : ' is-absolute'));
			container
				.find('.b-progress-wrapper')
				.remove();

			if (params.isFixed && animateProgressCounter > 0) {
				animateProgressCounter--;
			}
			if (body.hasClass(PROGRESS_BODY_OVERFLOW_CLASS) && animateProgressCounter < 1) {
				body.removeClass(PROGRESS_BODY_OVERFLOW_CLASS);
			}
		}

		function setLabel (label: string) {
			container
				.find('.b-progress-label')
				.html(label);
		}

		return {
			enable,
			disable,
			setLabel,
		};
	};
};
